import React from "react";
import Modal from "../../assets/components/ModalComonent";

const RulesPopUp = ({ show, handleClose }) => {
  const tutorialDialog = (
    <>
      <div className="w-100 text-center">
        <p className="font-weight-bold">راهنما</p>
        <p>
          اگر کنار هر ایموجی بلندگو 🔊 بود به معنای صدای ان ایموجی است
          <br />
          <br />
          اگر علامت مساوی = کنار ایموجی امد به معنای معادل ان است
          <br />
          <br />
          اگر cun امد به معنای اسم ان کشور است
          <br />
          <br />
          اگر en یا عربی امد یعنی معادل فارسی ان در زبان انگلیسی
          <br />
          <br />
          اگر علامت دو فلش برعکس‌ 🔁 بود یعنی حروفش را برعکس کن
          <br />
          <br />
          💸کنار نماد یک کشور نشان دهنده ی واحد پول
          <br />
          <br />
          ❌مخالف کلمه
        </p>
      </div>
    </>
  );

  return (
    <Modal
      open={show}
      closeHandler={handleClose}
      dialogContent={tutorialDialog}
    />
  );
};

export default RulesPopUp;
